<template>
  <div class="chatInputBox">
    <div v-if="isSummaryStatus" class="actionActivatorWrap">
      <summary-dialog :brandId="brandId" :agentId="agentId" :chatRoomId="chatRoomId" :isPermission="isPermission"
                      :orderList="orderList"></summary-dialog>
    </div>
    <div v-else-if="isActiveStatus" class="activeInput">
      <div class="text">
        <v-textarea
          v-model="messageInput"
          :placeholder="!isLineChat ? 'メッセージを入力してください' : ''"
          name="messageInput"
          hide-details
          ref="input"
          class="chatTextArea"
          no-resize
          outline
          :height="getInputHeight"
          :disabled="isLineChat"
          :style="notSendMsg"
          @keypress.enter.exact.prevent
          @keypress.enter.exact="sendMessage"
          @keypress.enter.shift.exact="newline"
        ></v-textarea>
        <v-btn
          depressed
          class="sendBtn"
          :loading="loading"
          :disabled="!isPermission || loading && !isActiveStatus || isLineChat"
          :height="getInputHeight"
          @click.native="sendMessage">
          <i class="UXicon-send"></i>
        </v-btn>
      </div>
      <div class="options">
        <div class="resizeOptionBox resizeBtnBox">
          <v-btn flat icon @click="changeInputAreaSize(0)" :class="{'selected': inputAreaHeightLevel === 0}">
            <i class="UXicon-text_short"></i>
          </v-btn>
          <v-btn flat icon @click="changeInputAreaSize(1)" :class="{'selected': inputAreaHeightLevel === 1}">
            <i class="UXicon-text_middle"></i>
          </v-btn>
          <v-btn flat icon @click="changeInputAreaSize(2)" :class="{'selected': inputAreaHeightLevel === 2}">
            <i class="UXicon-text_long"></i>
          </v-btn>
        </div>
        <div class="option2">
          <v-btn flat icon color="#FFFFFF" class="iconBtn" @click="makeCall" :disabled="!isPermission" :style="{opacity: isPermission  || 0.3}" v-if="!$targetMake.isSeller"><i class="UXicon-call"></i></v-btn>
          <call-layer :open="showCallPopup"></call-layer>
          <emoji-picker :chatRoomId="chatRoomId" :channelName="channelName" :isPermission="isPermission" ></emoji-picker>
          <!-- 画像転送フォーム -->
          <v-dialog
            persistent
            v-model="imageSendDialog"
            :disabled="!isPermission || loading || isLineChat"
            width="750px"
            height="773px">
            <v-btn flat icon color="#FFFFFF" class="iconBtn" slot="activator" :disabled="!isPermission" :style="{opacity: isPermission || 0.3}"><i class="UXicon-image"></i></v-btn>
            <div class="layerPopup">
              <div class="layerTit">画像の送信</div>
              <div class="layerContent">
                <div>
                  <v-tabs class="tabBox UXTab" v-model="imageTabType">
                    <v-tab href="#send-instant">すぐに送信</v-tab>
                    <!-- <v-tab href="#send-template">画像テンプレート</v-tab> -->
                  </v-tabs>
                  <div class="imageTabCon">
                    <div v-show="imageTabType === 'send-instant'" class="instantBox">
                      <div class="uploadArea">
                        <v-img
                          width="150px"
                          height="150px"
                          max-width="150px"
                          max-height="150px"
                          class="preview"
                          :src="imagePath">
                          <span v-if="!imagePath">画像<br>プレビュー</span>
                        </v-img>
                        <div class="imageBtnBox">
                            <upload-btn
                              ref="instantFileInput"
                              accept="image/png, image/jpeg, image/bmp"
                              title="ファイル選択"
                              @file-update="fileSelectEvent"
                              @click.native="$refs.instantFileInput.clear()"
                              :noTitleUpdate="true"
                              :disabled="loading"
                              outline
                              class="imageUploadBtn">
                            </upload-btn>
                            <span>(画像形式 : jpg/png/gif, 最大容量: 2MB)</span>
                        </div>
                      </div>
                      <div class="cenBtn alignBtm">
                        <v-btn outline round large class="UXbtn" @click="closeImageSendDialog">キャンセル</v-btn>
                        <v-btn round dark large color="#ff8c8c" class="UXbtn" :disabled="loading||!imagePath" @click="sendImageMessage">送信</v-btn>
                      </div>
                    </div>

                    <!-- <div v-show="imageTabType === 'send-template'" class="imgTemplateBox">
                      <div class="imageSearchBar">
                        <table class="UXTbl">
                          <colgroup>
                            <col style="width:130px;"/>
                            <col/>
                          </colgroup>
                          <tbody>
                          <tr>
                            <th style="height: 50px">検索</th>
                            <td style="height: 50px;padding:0 0 0 15px">
                              <div style="display: flex;flex-direction: row; align-items: center">
                                <v-text-field
                                  v-model="searchData"
                                  placeholder="テンプレート名を検索"
                                  class="UXinput UXicon-search search-input"
                                  style="flex-grow: 1"
                                  color="#000000"
                                  :append-icon="'search'"
                                  @click:append="fetchBrandImageTemplates(1)"
                                  @keyup.enter.exact="fetchBrandImageTemplates(1)"
                                  hide-details
                                  outline
                                  solo
                                ></v-text-field>
                                <v-btn flat icon @click="setData"><i class="UXicon-reset" style="color: #919191"></i></v-btn>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="templateListToolbar">
                        <inp-pagination v-model="pagination.page" :length="pagination.totalPages"
                                        :isShowSize="false" :pageSize="8"
                                        @input="paginationClick" class="imgTemplatePagination"></inp-pagination>
                        テンプレートリスト
                      </div>
                      <div class="imageTemplateCon" v-if="imageTemplateData.length > 0">
                        <div>
                          <div v-for="(template, index) in imageTemplateData" :key="index" class="templateItem">
                            <div class="imageBox">
                              <v-img
                                width="150px"
                                height="150px"
                                max-width="150px"
                                max-height="150px"
                                contain
                                :src="template.answer"
                                class="templateImg"
                                :class="{'on': selectedTemplate === template}"
                                alt="テンプレート画像"
                                @error="onImgError(template)"
                                @click="selectedTemplate=template">
                              </v-img>
                              <div class="selectedTpl" v-show="selectedTemplate === template"></div>
                            </div>
                            <div class="txtBox">
                              {{template.question}}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="imageTemplateData.length === 0" class="UXnotData large" style="height:446px;">画像テンプレートがありません。</div>
                      <div class="cenBtn" style="margin-top: 10px; margin-bottom: 10px">
                        <v-btn outline round large class="UXbtn" @click="closeImageSendDialog">キャンセル</v-btn>
                        <v-btn round dark large color="#ff8c8c" class="UXbtn" :loading="loading" @click="sendImageTemplate" :disabled="!isPermission">送信</v-btn>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="layerClose">
                <v-btn flat icon @click="closeImageSendDialog">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </div>
          </v-dialog>
        </div>
        <div class="option3">
          <transfer-dialog :brandId="brandId" :agentId="agentId" :chatRoomId="chatRoomId" :status="status" :isPermission="isPermission"
                           :isDisabled="loading" class="mr-1"></transfer-dialog>
          <quit-dialog :chatRoomId="chatRoomId" :isDisabled="loading" :survey="survey" :isVersion2="isVersion2" :agentId="agentId"
          :isPermission="isPermission" :is-mail-input="false" :isLineChat="isLineChat"></quit-dialog>
        </div>

        <send-template-dialog :type="type" :active="active" :sendMessage="sendMessage" :setMessage="setMessage"
                              :chatRoomId="chatRoomId"></send-template-dialog>
      </div>
    </div>
    <div v-else-if="isWaitingChatRoomCanBeStarted" class="actionActivatorWrap">
      <pick-chat-room :chatRoomId="chatRoomId" :roomInfo="roomInfo" :isPermission="isPermission"></pick-chat-room>
    </div>
  </div>
</template>

<script>
import uploadBtn from 'vuetify-upload-button'
import {mapGetters, mapMutations} from 'vuex'
import helper from 'util/helpers'
import chatRoomUtils from 'util/chatroom'
import eventBus from '@/event_bus'
import summaryDialog from './summary_dialog'
import transferDialog from './transfer_dialog'
import quitDialog from './quit_dialog'
import sendTemplateDialog from '../right/send_template_dialog'
import emojiPicker from './emoji_picker'
import pickChatRoom from './pick_chat_room'
import CallLayer from '@/views/callOperation/components/CallLayer'
import InpPagination from '@/components/InpPagination'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'chat_room_input',
  components: {
    uploadBtn,
    emojiPicker,
    pickChatRoom,
    summaryDialog,
    transferDialog,
    quitDialog,
    sendTemplateDialog,
    CallLayer,
    InpPagination,
    VuePerfectScrollbar
  },
  props: {
    brandId: {
      type: Number
    },
    agentId: {
      type: Number
    },
    loginId: {
      type: String
    },
    chatRoomId: {
      type: Number
    },
    active: {
      type: Boolean
    },
    status: {
      type: String
    },
    customerInfo: {
      type: Object
    },
    channelName: {
      type: String
    },
    displayingChatRoomStatus: {
      type: String
    },
    orderList: {
      type: Array
    },
    categoryId: {
      type: Number
    },
    distributionOption: {
      type: String
    },
    isPickAvailable: {
      type: Boolean,
      default: true
    },
    roomInfo: {
      type: Object
    },
    isPermission: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters([
      'activeChatRoomList',
      'transferredChatRoomList',
      'inputAreaHeightLevel',
      'mallId',
      'isPossibleWaitingCategory',
      'isSummaryCompleted',
      'callAgentStatus',
      'displayingChatRoomId'
    ]),
    isWaitingChatRoomCanBeStarted () {
      // 전체탭에 있는 상담 대기중 방의 '상담 시작하기' 버튼 노출 제어용
      // 상담 대기중인 방을 보려면 전체탭에서 선택해 보는 방법밖에 없으므로 선택한 탭의 종류(전체)와 그 방의 상태(대기중)로 체크

      // 만약 '상담 배분 관리'를 사용할경우 (사용안할 경우 아래 조건은 넘어간다)
      // 전체탭이고 대기중 상담방이면서 상담사가 배분받은 카테고리 아이디와 챗룸의 카테고리가 같으면 상담하기 버튼 활성화

      if (!this.isPermission) {
        return false
      } else {
        if (this.distributionOption === 'CATEGORY_ASSIGNMENT' || this.distributionOption === 'CATEGORY_AUTO_ASSIGNMENT') {
          return chatRoomUtils.showPickButton(this.status, this.displayingChatRoomStatus, this.distributionOption, this.isPickAvailable) && this.isPossibleWaitingCategory(this.categoryId)
        }
        return chatRoomUtils.showPickButton(this.status, this.displayingChatRoomStatus, this.distributionOption, this.isPickAvailable)
      }
    },
    isActiveStatus () {
      return this.status === 'ACTIVE' || this.status === 'TRANSFER'
    },
    isSummaryStatus () {
      return this.status === 'SUMMARY_WAITING'
    },
    getInputHeight () {
      switch (this.inputAreaHeightLevel) {
        case 0:
          return '110'
        case 1:
          return '180'
        case 2:
          return '255'
        case 3:
          return '330'
      }
    }
  },
  watch: {
  },
  created () {
    // 로컬 스토리지값이 null 이면 0으로 초기화
    if (localStorage.getItem('INPUT_AREA_HEIGHT') === null || undefined) {
      localStorage.setItem('INPUT_AREA_HEIGHT', '0')
    } // 뷰엑스에 저장된 값이 있으면 불러오고 없으면 스토리지 값으로 초기화
    this.inputAreaHeightResize(this.inputAreaHeightLevel ? this.inputAreaHeightLevel : parseInt(localStorage.getItem('INPUT_AREA_HEIGHT')))
    eventBus.$on(`add-emoji-to-message-input-${this.chatRoomId}`, (emoji, emojiId) => {
      this.addEmojiToMessageInput(this.chatRoomId, emoji, emojiId)
    })
    this.fetchSurveyOption()
    this.$eventBus.$on(`ABOUT_TALK_EDIT_AND_SEND-${this.displayingChatRoomId}`, text => {
      this.setMessage(text)
    })
    this.$eventBus.$on(`ABOUT_TALK_IMMEDIATE_SEND-${this.displayingChatRoomId}`, text => {
      if (this.displayingChatRoomId && this.displayingChatRoomId === this.chatRoomId) {
        this.setMessage(text)
        this.sendMessage()
      }
    })
    // 라인 메시지수
    if (this.channelName === 'LINE') {
      this.lineSendEnable()
    }
  },
  destroyed () {
    eventBus.$off(`add-emoji-to-message-input-${this.chatRoomId}`)
    eventBus.$off(`ABOUT_TALK_EDIT_AND_SEND-${this.chatRoomId}`)
    eventBus.$off(`ABOUT_TALK_IMMEDIATE_SEND-${this.chatRoomId}`)
  },
  data () {
    return {
      pagination: {
        page: 0,
        totalPages: 0,
        size: 8,
        totalItems: 0
      },
      imageTemplateData: [],
      type: 'TEXT',
      addImageDialog: false,
      showCallPopup: false,
      loading: false,
      valid: false,
      messageInput: '',
      imageSendDialog: false,
      imageName: '',
      imagePath: '',
      editStatus: false,
      // search: '',
      rules: {
        message: v => !!v || 'メッセージを入力してください。'
      },
      survey: {
        surveyList: [],
        disableSurveySetting: false,
        useSurvey: false, // 브랜드 설정
        sendSurvey: false, // 상담사 설정
        surveyNumberSendChannel: '', // 전송채널(SMS, KAKAO_INSTANT_MESSAGE)
        useAlternativeMessageOnFail: false,
        result: ''
      },
      isVersion2: false,
      lineIndexData: {
        index: [],
        emojiText: [],
        emojiId: []
      },
      messageInputSelectionStart: 0,
      messageInputMaxLength: 1000,
      imageTabType: 'send-instant',
      selectedTemplate: {},
      imageLoadFail: false,
      lineCountData: {
        now: 0,
        total: 0,
        isLine: false
      },
      isLineChat: false,
      notSendMsg: {
        background: ''
      }
    }
  },
  methods: {
    ...mapMutations([
      'inputAreaHeightResize'
    ]),
    setMessage (templateAnswer) {
      this.messageInput = templateAnswer
    },
    addImageDialogOption () {
      this.addImageDialog = true
      this.editStatus = false
    },
    makeCall () {
      if (this.callAgentStatus === '通話中') {
        this.$toasted.error('すでに通話中です')
        return
      }

      if (this.callAgentStatus === '後処理中') {
        this.$toasted.error(this.isSummaryCompleted ? '後処理中です。 状態変更後に通話可能です。' : '後処理登録後に通話可能です。')
        return
      }

      this.showCallPopup = true
    },
    fetchSurveyOption () {
      this.axios.get('/api/external/survey/fetchBrandSurveyOption', {
        params: {
          type: 'CLOUD_GATE',
          brandId: this.brandId
        }
      }).then(result => {
        if (result.data.code !== 0) throw result.data
        const option = JSON.parse(result.data.data.surveyData)
        // this.survey.disableSurveySetting = !option.ALLOW_SURVEY_SETTINGS
        this.survey.disableSurveySetting = false
        this.survey.useSurvey = option.USE_SURVEY
        this.survey.sendSurvey = option.USE_SURVEY
        this.survey.surveyNumberSendChannel = option.SURVEY_NUMBER_SEND_CHANNEL
        this.survey.useAlternativeMessageOnFail = option.USE_ALTERNATIVE_MESSAGE_ON_FAIL
        this.survey.sendTiming = option.SEND_TIMING
        this.isVersion2 = result.data.data.webChatInfo.isVersion2
        if (this.survey.useSurvey) this.fetchSurveyList()
      })
        .catch(error => {
          if (error.code !== -9004) {
            this.$alertMsg(error.message)
          }
        })
    },
    fetchSurveyList () {
      this.axios.get('/api/external/survey/fetchSurveyList', {
        params: {
          type: 'CLOUD_GATE',
          brandId: this.brandId,
          surveyStatus: 'ACTIVE'
        }
      }).then(result => {
        if (result.data.code !== 0) throw result.data.message
        this.survey.surveyList = result.data.data
      })
        .catch(error => this.$alertMsg(error))
    },
    newline () {
      this.messageInput = `${this.messageInput}`
    },
    sendMessage () {
      if (this.loading === false) {
        this.loading = true
        if (!helper.isStringValid(this.messageInput.trim())) {
          this.loading = false
          return
        }

        if (this.checkMessageLength()) {
          this.loading = false
          this.$alertMsg('最大文字数は ' + this.messageInputMaxLength + '字です。')
          return
        }
        // 라인형식 텍스트(이모티콘 포함) 생성
        let apiUrl = ''
        let message = {}
        if (this.channelName === 'LINE') {
          apiUrl = '/api/chat/sendLineTextChatMessage'
          let lineTextmessage = this.messageInput
          let lineData = this.lineIndexData
          // 이모지가 유무에 따른 객체 변경
          if (lineData.emojiText.length > 0) {
            lineData.emojiText.forEach(key => {
              let deleteTextIndex = lineTextmessage.indexOf(key)
              if (deleteTextIndex === -1) {
                this.lineIndexData.emojiText.splice(this.lineIndexData.emojiText.indexOf(key), 1)
                this.lineIndexData.emojiId.splice(this.lineIndexData.emojiText.indexOf(key), 1)
              }
              lineTextmessage = lineTextmessage.replace(key, '$')
            })
            message = {
              text: this.messageInput.trim(),
              line: {
                text: lineTextmessage,
                emojiId: lineData.emojiId,
                index: this.textIndexOfAll(lineTextmessage)
              }
            }
            if (lineData.emojiText.length === 0) {
              delete message.line
            }
          } else {
            message = {
              text: this.messageInput.trim()
            }
          }
          this.resetTextData()
        } else {
          apiUrl = '/api/chat/sendTextChatMessage'
          message = this.messageInput.trim()
          this.resetTextData()
        }
        this.loading = false
        this.axios.post(apiUrl, {
          agentId: this.agentId,
          chatRoomId: this.chatRoomId,
          message: this.channelName === 'LINE' ? JSON.stringify(message) : message,
          url: ''
        }).then(res => {
          if (res.data.code !== 0) throw res.data.message

          // 채팅 여러번 보낼시 글자가 누락되는 버그때문에 주석처리 2020/02/10
          /* this.messageInput = '' */
        }, () => this.$alertMsg(this.$const.SYS_ERR))
          .catch(errorMsg => this.$alertMsg(errorMsg))
          .finally(() => {
            this.loading = false
            if (this.channelName === 'LINE') {
              this.lineSendEnable()
            }
          })
      } else {
        return false
      }
      this.$refs.input.focus()
    },
    sendImageMessage () {
      if (this.loading) return

      this.loading = true
      this.axios.post('/api/chat/sendImageChatMessage', {
        agentId: this.agentId,
        chatRoomId: this.chatRoomId,
        message: '',
        imgName: this.imageName,
        url: this.imagePath
      }).then(res => {
        if (res.data.code !== 0) throw res.data.message

        this.imageName = ''
        this.imagePath = ''
        this.closeImageSendDialog()
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => this.$alertMsg(errorMsg))
        .finally(() => {
          this.loading = false
          this.lineSendEnable()
        })
    },
    closeImageSendDialog () {
      this.imageSendDialog = false
      this.imagePath = ''
    },
    fileSelectEvent (file) {
      // 크롬 버그 개선
      if (!file) return
      const validTypes = ['image/png', 'image/jpeg', 'image/bmp']
      if (!validTypes.includes(file.type)) {
        this.$alertMsg('許可されていないファイル拡張子です。')
        return
      }
      if (this.loading) return

      this.loading = true
      const formData = new FormData()
      formData.append('file', file)
      formData.append('loginId', this.loginId)

      let requestUrl = '/api/external/fileUpload'

      this.axios.post(requestUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.data.code !== 0) throw res.data.message

        this.imageName = file.name
        this.imagePath = res.data.data.imageUrl
      }, () => this.$alertMsg(this.$const.SYS_ERR))
        .catch(errorMsg => this.$alertMsg(errorMsg))
        .finally(() => {
          this.loading = false
        })
    },
    changeInputAreaSize (size) {
      this.inputAreaHeightResize(size)
      localStorage.setItem('INPUT_AREA_HEIGHT', this.inputAreaHeightLevel)
    },
    addEmojiToMessageInput (chatRoomId, emoji, emojiId) {
      if (this.channelName === 'LINE') {
        if (this.lineIndexData.emojiId.length > 19) {
          this.$alertMsg('LINE絵文字の最大個数は20個です。')
          return false
        }
      }
      if (this.active && (helper.findByChatRoomId(this.activeChatRoomList, chatRoomId) !== undefined || helper.findByChatRoomId(this.transferredChatRoomList, chatRoomId) !== undefined)) {
        if (helper.isObjectValid(this.$refs.input.$el)) {
          this.messageInputSelectionStart = this.$refs.input.$el.querySelector('textarea').selectionStart
        } else {
          this.messageInputSelectionStart = 0
        }

        let beforeSelection = this.messageInput.substring(0, this.messageInputSelectionStart)
        let afterSelection = this.messageInput.substring(this.messageInputSelectionStart, this.messageInput.length)

        this.messageInput = beforeSelection + emoji + afterSelection
        // 라인 이모티콘 전송용 텍스트 만들기
        this.lineIndexData.emojiText.push(emoji)
        this.lineIndexData.emojiId.push(emojiId)
        this.messageInputSelectionStart = this.$refs.input.$el.querySelector('textarea').selectionStart + emoji.length

        setTimeout(() => {
          this.$refs.input.$el.querySelector('textarea').selectionStart = this.messageInputSelectionStart
        }, 10)
      }
    },
    checkMessageLength () {
      if (this.messageInput.length > this.messageInputMaxLength) {
        this.messageInput = helper.reduceByLength(this.messageInput, this.messageInputMaxLength)
        return true
      }

      return false
    },
    onImgError (template) {
      template.answer = 'https://storage.googleapis.com/cloud-gate-storage/ehdrudals/xBkuBBpOJZ.png'
    },
    lineSendEnable () {
      this.axios.get('/api/external/line/totalMessagingCount', {
        params: {
          brandId: this.brandId
        }
      }).then(res => {
        this.$emit('line-reset-connect-input')
        this.lineCountData.total = res.data.data.total
        this.lineCountData.now = res.data.data.now
        if (this.lineCountData.now >= this.lineCountData.total) {
          if (this.lineCountData.total === 1000) {
            this.messageInput = '無料メッセージを全て使用されました。'
          } else {
            this.messageInput = '使用可能なメッセージを全て使用されました。'
          }
          this.isLineChat = true
          this.notSendMsg.background = '#f5f5f5'
        }
      })
    },
    textIndexOfAll (text) {
      let nextPosition = -1
      let findArray = []
      for (let i = 0; i < text.length; i++) {
        let findTextIndex = text.indexOf('$', nextPosition + 1)
        nextPosition = findTextIndex
        if (findTextIndex !== -1) {
          findArray.push(findTextIndex)
        } else {
          break
        }
      }
      this.lineIndexData.index = findArray
      return findArray
    },
    resetTextData () {
      this.messageInput = ''
      this.lineIndexData = {
        index: [],
        emojiText: [],
        emojiId: []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.UXTab {
  /deep/ .v-tabs__wrapper {
    .v-tabs__item.v-tabs__item--active,
    .v-tabs__container {
      background-color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/operation/fragments/chat_area/chat_room_input.vue